import ClickAwayListener from '@mui/material/ClickAwayListener';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import styles from '@styles/components/TablePoppers.module.css';
import { CSSProperties, useEffect, useState } from 'react';
import DatePicker, { FlexibleDateMultiPicker } from './DatePicker';
import DateRangePicker from './DateRangePicker';

// import { ReactComponent as DayPickerSVG} from '@assets/SVGs/PresenteeismTable/DayPickerSVG.svg'
import { ReactComponent as SearchSVG } from '@assets/SVGs/PresenteeismTable/SearchSVG.svg';
import { ReactComponent as MultiColorOrgSVG } from '@assets/SVGs/Sidebar/MultiColorOrgSVG.svg';
// import { ReactComponent as OrgSVG} from '@assets/SVGs/Sidebar/OrgSVG.svg'
import { ReactComponent as ArrowsSVG } from '@assets/SVGs/GeneralUse/ArrowsSVG.svg';
import { ReactComponent as MultiOrgSVG } from '@assets/SVGs/GeneralUse/MultiOrgSVG.svg';
import { Application } from '@core/Application';
/* 

    Way to use poppers

    const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClickOnDiv = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen((previousOpen) => !previousOpen);
    };

    <div onClick={handleClickOnDiv}>
        {open && <CustomPopper />}
    </div>
 
    const CustomPopper = ({isOpen, clickAwayHandler, anchorElement, placement,}) => (
        <ClickAwayListener onClickAway={clickAwayHandler}>
            <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: 1}} transition>
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <Paper className={styles['']}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>

                    </Paper>
                </Fade>
            )}
            </Popper>
        </ClickAwayListener>   
    )
*/

const DayPicker = ({days, setDays, setIsOpen, showSelectAll = true}) => {
    const handleDayClick = (day) => {
        if (days.includes(day)){
            setDays(days.filter((d) => d !== day))
        }else {
            setDays([...days, day])
        }
    }

    const handleSelectAllClick = () => {
        if (days.length > 0){
            setDays([])
        } else {
            setDays(["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"])
        }
    }

    return (
        <div className={styles['daypicker-content']}>
            <div className={styles['daypicker-days-container']}>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Lunes") && styles['elegido']}`} onClick={() => handleDayClick('Lunes')}>L</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Martes") && styles['elegido']}`} onClick={() => handleDayClick('Martes')}>M</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Miercoles")&& styles['elegido']}`} onClick={() => handleDayClick('Miercoles')}>X</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Jueves") && styles['elegido']}`} onClick={() => handleDayClick('Jueves')}>J</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Viernes") && styles['elegido']}`} onClick={() => handleDayClick('Viernes')}>V</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Sabado") && styles['elegido']}`} onClick={() => handleDayClick('Sabado')}>S</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Domingo") && styles['elegido']}`} onClick={() => handleDayClick('Domingo')}>D</div>
            </div>
            {showSelectAll ? (
                <div className={styles['daypicker-pickall-container']}>
                    <p className={styles['daypicker-pickall']} onClick={handleSelectAllClick}>Seleccionar todos</p>
                </div>
            ) : null}

            <div className={styles['daypicker-actions-container']}>
                <div className={`${styles['daypicker-button']} ${styles['daypicker-button-cancelar']}`} onClick={() => {
                    setDays([])
                    setIsOpen(false)
                }}>Cancelar</div>
                <div className={`${styles['daypicker-button']} ${styles['daypicker-button-aceptar']}`} onClick={() => setIsOpen(false)}>Aceptar</div>
            </div>
        </div>
    )
}


const DayPickerReusable = ({days = [], setDays, style = {}}) => {
    const handleDayClick = (day) => {
        if (days.includes(day)){
            setDays(days.filter((d) => d !== day))
        }else {
            setDays([...days, day])
        }
    }

    const handleSelectAllClick = () => {
        if (days.length > 0){
            setDays([])
        } else {
            setDays(["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"])
        }
    }

    return (
        <div className={styles['daypicker-content']} style={style}>
            <div className={styles['daypicker-days-container']}>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Lunes") && styles['elegido']}`} onClick={() => handleDayClick('Lunes')}>L</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Martes") && styles['elegido']}`} onClick={() => handleDayClick('Martes')}>M</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Miercoles")&& styles['elegido']}`} onClick={() => handleDayClick('Miercoles')}>X</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Jueves") && styles['elegido']}`} onClick={() => handleDayClick('Jueves')}>J</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Viernes") && styles['elegido']}`} onClick={() => handleDayClick('Viernes')}>V</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Sabado") && styles['elegido']}`} onClick={() => handleDayClick('Sabado')}>S</div>
                <div className={`${styles['daypicker-day']} ${days.find(day => day === "Domingo") && styles['elegido']}`} onClick={() => handleDayClick('Domingo')}>D</div>
            </div>
            <div className={styles['daypicker-pickall-container']}>
                <p className={styles['daypicker-pickall']} onClick={handleSelectAllClick}>Seleccionar todos</p>
            </div>
        </div>
    )
}


const DayPickerPopper = ({isOpen, setIsOpen, clickAwayHandler, anchorElement, placement, style = {} as CSSProperties, selectedDays, setSelectedDays, showSelectAll = true}) => (
    <ClickAwayListener onClickAway={clickAwayHandler}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: style.zIndex ?? 1}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={styles['daypicker-container']} style={style}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <DayPicker setDays={setSelectedDays} days={selectedDays} setIsOpen={setIsOpen} showSelectAll={showSelectAll}/>
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
)

const BuildingPicker = ({buildings, setBuildingsToFilter, initBuildingsToFilter}) => {
    const [pickedBuildings, setPickedBuildings] = useState(initBuildingsToFilter)
    const [searchField, setSearchField] = useState('')

    const handleSearchBarTyping = (e) => {
        setSearchField(e.target.value.toLowerCase().replace(/\s/g, ''))
    }

    const handleAllBuildingsClick = () => {
        if (pickedBuildings.length === buildings.length){
            setPickedBuildings([])
        }else {
            setPickedBuildings(buildings.map((building) => building.name))
        }
    }

    const handleBuildingClick = (buildingName) => {
        if (pickedBuildings.includes(buildingName)){
            setPickedBuildings(pickedBuildings.filter((building) => building !== buildingName))
        }else {
            setPickedBuildings([...pickedBuildings, buildingName])
        }
    }

    const handleQuitarClick = (e) => {
        e.stopPropagation()
        setPickedBuildings([])
        setBuildingsToFilter([])
    }

    const handleAplicarClick = (e) => {
        e.stopPropagation()
        setBuildingsToFilter(pickedBuildings)
    }

    return (
        <div className={styles['buildingpicker-content']}>
            <div className={styles['buildingpicker-header']}>
                <div className={styles['buildingpicker-svg-container']} style={{width: '29px', height: '29px'}}>
                    <MultiColorOrgSVG style={{fill: '#EC6C56'}}/>
                </div>

                <div className={styles['buildingpicker-header-az-filter-container']}>
                    <div className={styles['buildingpicker-svg-container']}>
                        <ArrowsSVG/>
                    </div>
                    <div className={styles['buildingpicker-header-az']}>
                        A-Z
                    </div>
                    <div className={styles['buildingpicker-header-az']}>
                        Z-A
                    </div>
                </div>
            </div>

            <div className={styles['buildingpicker-search-bar']}>
                    <div className={styles['buildingpicker-svg-container']}>
                        <SearchSVG/>
                    </div>

                    <div className={styles['buildingpicker-search-field-container']}>
                        <input type='text' placeholder='...' className={styles['buildingpicker-search-input']} onChange={e => {handleSearchBarTyping(e)}}/>
                    </div>
            </div>

            <div className={styles['buildingpicker-dropdown-container']}>
                <div className={styles['buildingpicker-dropdown']}>
                    <div style={{display: "flex", flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}}
                        onClick={() => {handleAllBuildingsClick()}}
                    >
                        <div className={styles['buildingpicker-svg-container']} style={{width: '30px', marginRight: '6.75px'}}>
                            <MultiOrgSVG/>
                        </div>
                        <p className={styles['buildingpicker-dropdown-text']}>Seleccionar todas</p>
                    </div>
                </div>


                <div className={styles['buildingpicker-dropdown-expanded-container']} 
                style={{
                    overflowY: 'auto', 
                    transition: 'height 0.2s ease-out',
                    pointerEvents: 'auto'
                }}>
                    {buildings
                    .filter((building) => building.name.toLowerCase().replace(/\s/g, '').includes((searchField.toLowerCase())))
                    .map((building) => {
                        return (           
                            <div className={`${styles['buildingpicker-dropdown-option-container']}`}>
                                <div className={`${styles['buildingpicker-dropdown-option']} ${pickedBuildings.includes(building.name) ? styles['picked'] : ''}`}
                                    onClick={() => {handleBuildingClick(building.name)}}
                                >
                                    <div className={styles['buildingpicker-svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                                        {
                                            pickedBuildings.includes(building.name) ?
                                            <MultiColorOrgSVG style={{fill: '#EC6C56'}}/>
                                            :
                                            <MultiColorOrgSVG style={{fill: '#DEDEE0'}}/>
                                        }

                                    </div>

                                    <p className={styles['buildingpicker-dropdown-text']} style={pickedBuildings.includes(building.name) ? {color: "#1E1D22", fontWeight: 600} : {}}>{building.name}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className={styles['buildingpicker-footer']}>
                <div style={{backgroundColor: '#F4F4F4', color: '#666'}} className={styles['buildingpicker-button']} onClick={handleQuitarClick}>Quitar</div>
                <div style={{backgroundColor: '#EC6C56', color: '#FFF'}} className={styles['buildingpicker-button']} onClick={handleAplicarClick}>Aplicar</div>
            </div>

        </div>
    )
}


const BuildingPickerPopper = ({isOpen, clickAwayHandler, anchorElement, placement, buildings, setBuildingsToFilter, initBuildingsToFilter}) => (
    <ClickAwayListener onClickAway={clickAwayHandler}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: 1}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={styles['buildingpicker-container']}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <BuildingPicker buildings={buildings} setBuildingsToFilter={setBuildingsToFilter} initBuildingsToFilter={initBuildingsToFilter}/>
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
)


interface BuildingQPOption {
    id: string;
    name: string;
    buildingID: string;
    functionalUnitID: string;
}

const BuildingFetchPicker = ({orgID, setBuildingsToFilter, initBuildingsToFilter}) => {
    const [pickedBuildings, setPickedBuildings] = useState(initBuildingsToFilter)
    const [searchField, setSearchField] = useState('')

    const [buildings, setBuildings] = useState<BuildingQPOption[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchQPsResponse();
    }, [])

    const fetchQPsResponse = async () => {
        setLoading(true);
        let currentPage = 0;
        let hasMore = true;
        try {
            while (hasMore) {
                const algoliaService = Application.shared().coreDependencies.algoliaService;
                const result = await algoliaService.searchQontactPointsV2(
                    orgID,
                    '',
                    currentPage,
                    200
                );
                currentPage += 1;

                const mappedResult: BuildingQPOption[] = result.hits.map(item => ({
                    id: item.id,
                    name: item.buildingName,
                    buildingID: item.buildingID,
                    functionalUnitID: item.functionalUnitID
                }));

                const buildingsInTotal = buildings.length + mappedResult.length;
                setBuildings((prev) => [...prev, ...mappedResult]);

                if (buildingsInTotal >= result.nbHits) {
                    hasMore = false;
                    break;
                }
            }
        } catch (err: any) {
            console.error('Fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchBarTyping = (e) => {
        setSearchField(e.target.value.toLowerCase().replace(/\s/g, ''))
    }

    /**
     * Selection travels as buildingID, never as the building's name.
     *
     * The rows of the table carry the name the building had on the day each record
     * was written — the worker writes it once and never refreshes it — while this
     * list gets the current name from Algolia. Matching those two by string meant
     * that renaming a QontactPoint made all of its earlier records invisible: the
     * table reported "no records" while the data sat there under the old name. The
     * ID does not change, so it is what the filter compares; the name is still what
     * the user reads.
     */
    const handleAllBuildingsClick = () => {
        if (pickedBuildings.length === buildings.length){
            setPickedBuildings([])
        }else {
            setPickedBuildings(buildings.map((building) => building.buildingID))
        }
    }

    const handleBuildingClick = (buildingID) => {
        if (pickedBuildings.includes(buildingID)){
            setPickedBuildings(pickedBuildings.filter((building) => building !== buildingID))
        }else {
            setPickedBuildings([...pickedBuildings, buildingID])
        }
    }

    const handleQuitarClick = (e) => {
        e.stopPropagation()
        setPickedBuildings([])
        setBuildingsToFilter([])
    }

    const handleAplicarClick = (e) => {
        e.stopPropagation()
        setBuildingsToFilter(pickedBuildings)
    }

    return (
        <div className={styles['buildingpicker-content']}>
            <div className={styles['buildingpicker-header']}>
                <div className={styles['buildingpicker-svg-container']} style={{width: '29px', height: '29px'}}>
                    <MultiColorOrgSVG style={{fill: '#EC6C56'}}/>
                </div>

                <div className={styles['buildingpicker-header-az-filter-container']}>
                    <div className={styles['buildingpicker-svg-container']}>
                        <ArrowsSVG/>
                    </div>
                    <div className={styles['buildingpicker-header-az']}>
                        A-Z
                    </div>
                    <div className={styles['buildingpicker-header-az']}>
                        Z-A
                    </div>
                </div>
            </div>

            <div className={styles['buildingpicker-search-bar']}>
                    <div className={styles['buildingpicker-svg-container']}>
                        <SearchSVG/>
                    </div>

                    <div className={styles['buildingpicker-search-field-container']}>
                        <input type='text' placeholder='...' className={styles['buildingpicker-search-input']} onChange={e => {handleSearchBarTyping(e)}}/>
                    </div>
            </div>

            <div className={styles['buildingpicker-dropdown-container']}>
                <div className={styles['buildingpicker-dropdown']}>
                    <div style={{display: "flex", flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}}
                        onClick={() => {handleAllBuildingsClick()}}
                    >
                        <div className={styles['buildingpicker-svg-container']} style={{width: '30px', marginRight: '6.75px'}}>
                            <MultiOrgSVG/>
                        </div>
                        <p className={styles['buildingpicker-dropdown-text']}>Seleccionar todas</p>
                    </div>
                </div>


                <div className={styles['buildingpicker-dropdown-expanded-container']} 
                style={{
                    overflowY: 'auto', 
                    transition: 'height 0.2s ease-out',
                    pointerEvents: 'auto'
                }}>
                    {buildings
                    .filter((building) => building.name.toLowerCase().replace(/\s/g, '').includes((searchField.toLowerCase())))
                    .map((building) => {
                        return (           
                            <div className={`${styles['buildingpicker-dropdown-option-container']}`}>
                                <div className={`${styles['buildingpicker-dropdown-option']} ${pickedBuildings.includes(building.buildingID) ? styles['picked'] : ''}`}
                                    onClick={() => {handleBuildingClick(building.buildingID)}}
                                >
                                    <div className={styles['buildingpicker-svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                                        {
                                            pickedBuildings.includes(building.buildingID) ?
                                            <MultiColorOrgSVG style={{fill: '#EC6C56'}}/>
                                            :
                                            <MultiColorOrgSVG style={{fill: '#DEDEE0'}}/>
                                        }

                                    </div>

                                    <p className={styles['buildingpicker-dropdown-text']} style={pickedBuildings.includes(building.buildingID) ? {color: "#1E1D22", fontWeight: 600} : {}}>{building.name}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className={styles['buildingpicker-footer']}>
                <div style={{backgroundColor: '#F4F4F4', color: '#666'}} className={styles['buildingpicker-button']} onClick={handleQuitarClick}>Quitar</div>
                <div style={{backgroundColor: '#EC6C56', color: '#FFF'}} className={styles['buildingpicker-button']} onClick={handleAplicarClick}>Aplicar</div>
            </div>

        </div>
    )
}


const BuildingPickerFetchPopper = ({isOpen, clickAwayHandler, anchorElement, placement, setBuildingsToFilter, initBuildingsToFilter, orgID}) => (
    <ClickAwayListener onClickAway={clickAwayHandler}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: 1}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={styles['buildingpicker-container']}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <BuildingFetchPicker orgID={orgID} setBuildingsToFilter={setBuildingsToFilter} initBuildingsToFilter={initBuildingsToFilter}/>
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
)


const DatePickerPopper = ({isOpen, clickAwayHandler, anchorElement, placement, updateDate, currentPickedDate}) => (
    <ClickAwayListener onClickAway={clickAwayHandler}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: 1000}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={`${styles['datepicker-container']} ${styles['normal']}`}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <DatePicker updateDate={updateDate} initValue={currentPickedDate}/>
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
)

const DatePickerPopperWithRange = ({
    isOpen, 
    onClickAway, 
    anchorElement, 
    placement, 
    inputType,
    setInputType,
    updateDate, 
    updateDateRange, 
    currentPickedDate,
    currentPickedDateRange
    }) => {
    const [clickedID, setClickedID] = useState(inputType)
    const [isExpanded, setIsExpanded] = useState(inputType === "Unica" ? true : false);
    
    const handleClick = (state) => {
        setInputType(state)
        setClickedID(state)
        if (state === 'Unica'){
            // updateDate(null)
            updateDateRange(null, null)
            setIsExpanded(true)
        }else {
            updateDate(null)
            // updateDateRange(null, null)
            setIsExpanded(false)
        }

    }

    const renderPicker = () => {
        switch (clickedID){
            case "Unica":
                return <DatePicker updateDate={updateDate} initValue={currentPickedDate}/>
            case "Rango":
                return <DateRangePicker updateDateRange={updateDateRange} style={{marginTop: '-15px'}} initValues={currentPickedDateRange}/>
            default:
                return <div/>
        }
    }

    return(
    <ClickAwayListener onClickAway={onClickAway}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: 1}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={`${styles['datepicker-container']}  ${isExpanded ? styles['expanded'] : ''}`}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <div className={styles['input-change-container']}>
                        <div className={`${styles['button']} ${clickedID === "Unica" ? styles['button-clicked'] : ''}`} onClick={(e) => {handleClick("Unica")}}>Fecha unica</div>
                        <div style={{width: '15px'}}/>
                        <div className={`${styles['button']} ${clickedID === "Rango" ? styles['button-clicked'] : ''}`} onClick={(e) => {handleClick("Rango")}}>Rango</div>
                    </div>
                    {renderPicker()}
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
    );
}


const NovedadPicker = ({novedades, selectedNovedad, setSelectedNovedad, onNovedadClick}) => {
    // const [novedadesList, setNovedadesList] = useState(novedades)
    const [searchField, setSearchField] = useState('')

    const handleSearchBarTyping = (e) => {
        setSearchField(e.target.value.toLowerCase().replace(/\s/g, ''))
    }

    const handleNovedadClick = (novedad) => {
        if (!selectedNovedad || novedad.name !== selectedNovedad.name) {  
            setSelectedNovedad(novedad);
        } else {  
            setSelectedNovedad(null);
        }
        onNovedadClick()        
    }

    const isNovedadSelected = (novedadName) => {
        if (!selectedNovedad) return false

        if (selectedNovedad.name === novedadName) {
            return true
        }
        return false
    }

    return (
        <div className={styles['novedadpicker-content']}>
            <div className={styles['novedadpicker-search-bar']}>
                    <div className={styles['novedadpicker-svg-container']}>
                        <SearchSVG/>
                    </div>

                    <div className={styles['novedadpicker-search-field-container']}>
                        <input type='text' placeholder='...' className={styles['novedadpicker-search-input']} onChange={e => {handleSearchBarTyping(e)}}/>
                    </div>
            </div>



            <div className={styles['novedadpicker-dropdown-container']} 
            style={{
                overflowY: 'auto', 
                transition: 'height 0.2s ease-out',
                pointerEvents: 'auto'
            }}>
                {novedades
                .filter((novedad) => novedad.name.toLowerCase().replace(/\s/g, '').includes((searchField.toLowerCase())))
                .map((novedad) => {
                    return (           
                        <div className={`${styles['novedadpicker-dropdown-option-container']}`}>
                            <div className={`${styles['novedadpicker-dropdown-option']} ${isNovedadSelected(novedad.name) ? styles['picked'] : ''}`}
                                onClick={() => {handleNovedadClick(novedad)}}
                            >
                                <div className={styles['novedadpicker-svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                                    {novedad.acronym}
                                </div>

                                <p className={styles['novedadpicker-dropdown-text']} style={isNovedadSelected(novedad.name) ? {color: "#1E1D22", fontWeight: 600} : {}}>{novedad.name}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>

    )
}


const NovedadPickerPopper = ({isOpen, clickAwayHandler, anchorElement, placement, novedades, selectedNovedad, setSelectedNovedad, zIndex = 1}) => (
    <ClickAwayListener onClickAway={clickAwayHandler}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: zIndex}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={styles['novedadpicker-container']}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <NovedadPicker novedades={novedades} selectedNovedad={selectedNovedad} setSelectedNovedad={setSelectedNovedad} onNovedadClick={clickAwayHandler}/>
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
)

//Expects an array of items like this
// [{id: 124, name: "Item 1", icon?: any}]
const DropdownListPicker = ({items, selectedItem, setSelectedItem, onChoose, searchFieldText}) => {
    const [searchField, setSearchField] = useState('')

    const handleSearchBarTyping = (e) => {
        setSearchField(e.target.value.toLowerCase().replace(/\s/g, ''))
    }

    const handleItemClick = (item) => {
        if (!selectedItem || item.id !== selectedItem.id) {  
            setSelectedItem(item);
        } else {  
            // setSelectedItem(null);
        }
        // onChoose()        
    }

    const isItemSelected = (itemID) => {
        if (!selectedItem) return false

        if (selectedItem.id === itemID) {
            return true
        }
        return false
    }

    return (
        <div className={styles['novedadpicker-content']}>
            <div className={styles['novedadpicker-search-bar']}>
                    <div className={styles['novedadpicker-svg-container']}>
                        <SearchSVG/>
                    </div>

                    <div className={styles['novedadpicker-search-field-container']}>
                        <input type='text' placeholder={searchFieldText} className={styles['novedadpicker-search-input']} onChange={e => {handleSearchBarTyping(e)}}/>
                    </div>
            </div>

            <div className={styles['novedadpicker-dropdown-container']} 
            style={{
                overflowY: 'auto', 
                transition: 'height 0.2s ease-out',
                pointerEvents: 'auto'
            }}>
                {items
                .filter((item) => item.name.toLowerCase().replace(/\s/g, '').includes((searchField.toLowerCase())))
                .map((item) => {
                    return (           
                        <div className={`${styles['novedadpicker-dropdown-option-container']}`}>
                            <div 
                                className={`${styles['novedadpicker-dropdown-option']} ${isItemSelected(item.id) ? styles['picked'] : ''}`}
                                onClick={() => {handleItemClick(item)}}
                            >
                                {/* <div className={styles['novedadpicker-svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                                    {item.acronym}
                                </div> */}
                                {item.icon &&
                                    <div className={styles['novedadpicker-svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                                        {item.icon}
                                    </div>
                                }
                                <p className={styles['novedadpicker-dropdown-text']} style={isItemSelected(item.id) ? {color: "#1E1D22", fontWeight: 600} : {}}>{item.name}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>

    )
}


const DropdownListPickerPopper = ({isOpen, clickAwayHandler, anchorElement, placement, items, selectedItem, setSelectedItem, zIndex = 1, searchFieldText = "..."}) => (
    <ClickAwayListener onClickAway={clickAwayHandler}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: zIndex}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={styles['novedadpicker-container']}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <DropdownListPicker items={items} selectedItem={selectedItem} setSelectedItem={setSelectedItem} onChoose={clickAwayHandler} searchFieldText={searchFieldText}/>
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
)




const MultiDatePickerPopper = ({isOpen, clickAwayHandler, anchorElement, placement, selectedDates, setSelectedDates, zIndex = 1, range = false}) => (
    <ClickAwayListener onClickAway={clickAwayHandler}>
        <Popper open={isOpen} anchorEl={anchorElement} placement={placement} style={{zIndex: zIndex}} transition>
        {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <Paper className={styles['multidatepicker-container']}  sx={{borderRadius: '10px', boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)'}} onClick={(e) => {e.stopPropagation()}}>
                    <MultiDatePicker selectedDates={selectedDates} setSelectedDates={setSelectedDates} isRange={range}/>
                </Paper>
            </Fade>
        )}
        </Popper>
    </ClickAwayListener>   
)


const MultiDatePicker = ({selectedDates, setSelectedDates, isRange = false}) => {

    const [innerDates, setInnerDates] = useState(selectedDates)

    const handleAcceptDateInput = (dates) => {
        setSelectedDates(dates)
    }

    return (
        <div className={styles['multidatepicker-content']}>
            <FlexibleDateMultiPicker
                dates={innerDates}
                updateDates={setInnerDates}
                daysStyle={{height: '24px', width: '24px'}}
                weekdayLabelStyle={{width: '24px', height: '20px'}}
                calendarHeaderStyle={{fontSize: '12px'}}
                calendarStyle={{width: '90%', height: '313px'}}
                isRange={isRange}
            />

            <div className={styles['buildingpicker-footer']}>
                <div style={{backgroundColor: '#F4F4F4', color: '#666'}} className={styles['buildingpicker-button']} onClick={() => {setSelectedDates([])}}>Quitar</div>
                <div style={{backgroundColor: '#EC6C56', color: '#FFF'}} className={styles['buildingpicker-button']} onClick={() => {handleAcceptDateInput(innerDates)}}>Aplicar</div>
            </div>
        </div>

    )    
}




export {BuildingPickerFetchPopper, BuildingPickerPopper, DatePickerPopper, DatePickerPopperWithRange, DayPickerPopper, DayPickerReusable, DropdownListPickerPopper, MultiDatePickerPopper, NovedadPickerPopper };
